import React from 'react';

import type { Text } from '@zillow/constellation';
import { Alert, FormField, Input, Label } from '@zillow/constellation';

import type { Section } from '../../../models/index';
import { UTILITIES_INFORMATION } from '../../../constants';
import type { HTMLElementEvent } from '../../../models/Types';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function UtilitiesInformation({ section, setSectionValues }: Props): JSX.Element {
  function onElectricityPhoneNumberChange(event: HTMLElementEvent<typeof Text>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [UTILITIES_INFORMATION.FIELD_NAME.ELECTRICITY_PHONE_NUMBER]: value,
    });
  }

  function setElectricityServiceProvider(event: HTMLElementEvent<typeof Text>): void {
    setSectionValues({
      [UTILITIES_INFORMATION.FIELD_NAME.ELECTRICITY_SERVICE_PROVIDER]: event.currentTarget.value,
    });
  }

  function onWaterSewerPhoneNumberChange(event: HTMLElementEvent<typeof Text>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [UTILITIES_INFORMATION.FIELD_NAME.WATER_SEWER_PHONE_NUMBER]: value,
    });
  }

  function setWaterSewerServiceProvider(event: HTMLElementEvent<typeof Text>): void {
    setSectionValues({
      [UTILITIES_INFORMATION.FIELD_NAME.WATER_SEWER_SERVICE_PROVIDER]: event.currentTarget.value,
    });
  }

  function onTrashRemovalPhoneNumberChange(event: HTMLElementEvent<typeof Text>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [UTILITIES_INFORMATION.FIELD_NAME.TRASH_REMOVAL_PHONE_NUMBER]: value,
    });
  }

  function setTrashRemovalServiceProvider(event: HTMLElementEvent<typeof Text>): void {
    setSectionValues({
      [UTILITIES_INFORMATION.FIELD_NAME.TRASH_REMOVAL_SERVICE_PROVIDER]: event.currentTarget.value,
    });
  }

  return (
    <>
      <Alert body="All utility provider information is required even if the utility won’t be paid by the tenant." />
      <FormField
        marginY="sm"
        label={<Label>Electricity service provider</Label>}
        control={
          <Input
            placeholder="(example: Sunrise Electric Company)"
            value={section.getFieldValue(UTILITIES_INFORMATION.FIELD_NAME.ELECTRICITY_SERVICE_PROVIDER)}
            onChange={setElectricityServiceProvider}
          />
        }
      />
      <FormField
        marginBottom="sm"
        label={<Label>Electricity service provider’s number</Label>}
        control={
          <Input
            type="tel"
            value={section.getFieldValue(UTILITIES_INFORMATION.FIELD_NAME.ELECTRICITY_PHONE_NUMBER)}
            onChange={onElectricityPhoneNumberChange}
          />
        }
      />
      <FormField
        marginBottom="sm"
        label={<Label>Water/sewer service provider</Label>}
        control={
          <Input
            placeholder="(example: Wonderland Waterworks)"
            value={section.getFieldValue(UTILITIES_INFORMATION.FIELD_NAME.WATER_SEWER_SERVICE_PROVIDER)}
            onChange={setWaterSewerServiceProvider}
          />
        }
      />
      <FormField
        marginBottom="sm"
        label={<Label>Water/sewer service provider’s number</Label>}
        control={
          <Input
            type="tel"
            value={section.getFieldValue(UTILITIES_INFORMATION.FIELD_NAME.WATER_SEWER_PHONE_NUMBER)}
            onChange={onWaterSewerPhoneNumberChange}
          />
        }
      />
      <FormField
        marginBottom="sm"
        label={<Label>Trash removal service provider</Label>}
        control={
          <Input
            placeholder="(example: Sunset Scavenger)"
            value={section.getFieldValue(UTILITIES_INFORMATION.FIELD_NAME.TRASH_REMOVAL_SERVICE_PROVIDER)}
            onChange={setTrashRemovalServiceProvider}
          />
        }
      />
      <FormField
        marginBottom="sm"
        label={<Label>Trash removal service provider’s number</Label>}
        control={
          <Input
            type="tel"
            value={section.getFieldValue(UTILITIES_INFORMATION.FIELD_NAME.TRASH_REMOVAL_PHONE_NUMBER)}
            onChange={onTrashRemovalPhoneNumberChange}
          />
        }
      />
    </>
  );
}
